// extracted by mini-css-extract-plugin
export default {"consentContainer":"styles_consentContainer__WOmeK","consentForm":"styles_consentForm__nG0qH"};